'use client';

import Image from 'next/image';
import Link from 'next/link';
import {Product} from '@delorand/db/schema/product';
import {renderHtmlFromString} from '@delorand/utils/render-html';
import {formatCurrency, getThumbnail, getVariant} from '@delorand/utils/shared';

export const Item = ({product}: {product: Product; flex?: boolean}) => {
  return (
    <Link
      href={`/item/${product.id}`}
      className={`group z-0 flex h-full w-full cursor-pointer gap-7 rounded-[15px] bg-black p-1.5`}
    >
      <div className={`w-[40%]`}>
        <Image
          alt={product.title.slice(0.5)}
          src={getThumbnail(product.images)}
          width={550}
          height={550}
          className={`w-full scale-95 rounded-[12px] bg-black/40 bg-contain transition-all group-hover:scale-100 group-hover:opacity-60`}
        />
      </div>

      <div className="flex h-full w-[60%] flex-col justify-start py-3 text-[#d6d6d6]">
        <h3 className="font-medium text-ellipsis">{product.title}</h3>
        <h5 className="line-clamp-2 text-sm">
          {renderHtmlFromString(product.description)}
        </h5>
        <p className="mt-2 pl-3 text-[19px] font-medium">
          {formatCurrency(getVariant(product.variants).price - 1)}
        </p>
        {/* //TODO add discounted price */}
        {/* <p className=" text-sm line-through text-neutral-400 pl-10">
          {formatCurrency(getVariant(product.variants).price - 1)}
        </p> */}
        {/* <div className='flex flex-col text-sm max-w-[80%] text-neutral-500'>
          {variantAttributes.slice(0, 2).map((attr) => (
            <div key={attr.name} className='flex'>
              <p>{attr.name}</p>s:{' '}
              <p className='ml-1 break-words '>
                {attr.options.slice(0, 7).join(', ')}
              </p>
            </div>
          ))}
        </div> */}
      </div>
    </Link>
  );
};
